<template>
  <div class="status">
    <div class="step center">
      <el-steps direction="vertical" :active="active" v-if="this.routeName != 'importVideo' && status.length && this.routeName != 'composition' && this.routeName != 'compositioncorrected' && this.routeName != 'compositionreport'">
        <el-step v-for="(item,index) in status" :key="index" :title="item.moduleName" :class="item.status == 1 ? 'el-icon-check-font': ''">
          <i class="el-icon-circle-none-outline" slot="icon" v-if="item.status == 0"></i>
          <i :class="routeName == 'transition'? 'el-icon-check': 'el-icon-check-ing'" slot="icon" v-if="item.status == 1"></i>
          <i class="el-icon-check" slot="icon" v-if="item.status == 2"></i>
          <i class="el-icon-check" slot="icon" v-if="item.status == 3"></i>
          <i class="el-icon-circle-lock-outline" slot="icon" v-if="item.status == 4"></i>
        </el-step>
      </el-steps>
    </div>
  </div>
</template>
<script>
export default {
  name: "Status",
  data() {
    return {
      active: 0, // 当前
      routeName: "" //当前路由
    };
  },
  props: {
    currentStatus: {
      type: Array,
      default: []
    },
    status: {
      type: Array,
      default: [] //item.status 0 未开始 1进行中 2完成 3跳过（其他阶段完成 已完成2,3一样）4 跳过（无需学习本阶段 未解锁）
    },
  },
  mounted() {
    // sModuleType 1 测试 2学习 3 综合
    this.routeName = this.$route.name;
    let currName = [];
    let statusName = [];
    if (this.currentStatus.length) { // 当前所在节点
      for (let i = 0; i < this.currentStatus.length; i++) {
        currName.push(this.currentStatus[i].moduleType);
      }
    }

    if (this.status.length) {
      for (let j = 0; j < this.status.length; j++) {
        statusName.push(this.status[j].moduleType);
      }
    }
    this.active = statusName.indexOf(currName[0]);
  }
};
</script>
<style lang="scss">
@import '@/assets/css/theme/register.scss';
.status {
  .step {
    width: 203px;
    height: 200px;
    margin-top: 46px;
  }
  .el-step__icon {
    width: 20px;
    height: 20px;
    display: inline-block;
  }
  .el-icon-check {
    position: relative;
    top: -1px;
    color: $theme-status-radius-color;
  }
  .el-icon-check:after{
    content: '';
    display: inline-block;
    width:20px;
    height:20px;
    border: 1px solid $theme-status-radius-color;
    -webkit-border-radius:50%;
    -moz-border-radius:50%;
    border-radius:50%;
    position: absolute;
    top:-4px;
    left:-4px;
  }
  .el-step__title {
    line-height: 21px;
  }
  .el-icon-circle-lock-outline{
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid $theme-status-radius-color;
  }
  .el-icon-circle-lock-outline:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    /*border: 1px solid #6DB7FF;*/
    // background: url("../assets/css/theme/#{$theme-name}/imgs/status-lock.png") no-repeat center;
    background-size: 55%;
    vertical-align: middle;
    position: relative;
    top: 0px;
    left: 0px;
  }
  .el-icon-circle-none-outline:before {
    content: "";
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid $theme-status-radius-color;
    position: relative;
    top:0;
    left:0;
  }
  .el-icon-check-ing {

    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    /*box-shadow: 0px 0px 10px 0px rgba(249, 242, 160, 0.5);*/
    background: $theme-status-radius-color;
    position: relative;
    top: 1px;
  }
  .el-icon-check-ing:before{
    content: "";
    background: $theme-status-radius2-color;
    width:22px;
    height:22px;
    position: absolute;
    top:-5px;
    left:-5px;
    border-radius: 50%;
  }
  .el-icon-check-font{
    .el-step__title.is-wait {
      color: $theme-status-radius-color;
    }
  }
  .highLight::before {
    color: #f9f2a0;
    border: 1px solid #f9f2a0;
  }

  .el-step__icon.is-text {
    border: 1px solid $theme-status-radius2-color;
  }

  .el-step__head.is-process {
    /*border-color: #f9f2a0;*/
    /*color: #f9f2a0;*/
    .el-step__icon.is-text {
      border:none;
      /*color: #f9f2a0;*/

    }
  }
  .el-step__head.is-wait {
    .el-step__icon.is-text {
      border: 0 solid $theme-status-radius2-color;
    }
  }
  .el-step__title.is-process {
    color: #FFF190;
  }
  .el-header {
    padding: 0;
  }
  .el-step__icon,
  .el-step__line {
    background: none;
  }
  .el-step.is-vertical .el-step__line {
    width: 1px;
    overflow: hidden;
  }
  .el-step__line {
    border-left: 1px dashed $theme-status-radius-color;
    height: 35px;
  }
  .el-step.is-vertical .el-step__line {
    top: 23px;
    left:10px;
  }
  .el-step__title.is-success,
  .el-step__title.is-wait,
  .el-step__head.is-finish {
    color: $theme-status-radius3-color;
    /*opacity: 0.5;*/
    font-size: 16px;
  }
  .el-step__head.is-success,
  .el-step__head.is-wait,
  .el-step__title.is-finish {
    color: $theme-status-radius3-color;
    border-color: $theme-status-radius-color;
    opacity: .65;
  }
  .el-steps--vertical {
    height: auto;
  }
  .el-step.is-vertical .el-step__title {
    padding-bottom: 49px;
    line-height:20px !important;
  }
  .el-step.is-vertical .el-step__title.is-process{
    margin-top: -3px;
  }
  .el-icon-circle-none-outline {
    width: 20px;
    height: 20px;
    position: relative;
  }
  .el-step__head.is-finish {
    .el-step__icon.is-text {
      border: 1px solid $theme-status-radius-color;
      .el-icon-check {
        color: $theme-status-radius3-color;
        &:after{
          border:none;
        }
      }
    }
  }
  .el-step.is-vertical .el-step__title.is-finish {
    opacity: 1 !important;
    color: $theme-status-radius-color !important;
  }
  .el-step__line-inner{
    border-width:0 !important;
  }
  .el-step__head{
    position: relative;
    .el-step__icon{
      position: absolute;
      top:0;
      left:0;
    }
  }

}


</style>





// WEBPACK FOOTER //
// src/components/Status.vue